export const checkList = [
  {
    id: 1,
    customerName: "TDS",
    totalChecklist: 3,
    checklist: [
      {
        category: "Category",
        name: "CheckList 1",
        removalScope: true,
        questions: [
          {
            question: " Is the Cable Depth meetings standards ?",
            score: 5,
            image: true,
          },
          {
            question: " Is the labeling correct ?",
            score: 3,
            image: false,
          },
        ],
      },
      {
        category: "Category 1",
        name: "CheckList 2",
        removalScope: false,
        questions: [
          {
            question: " Is the Cable Depth meetings standards ?",
            score: 5,
            image: true,
          },
          {
            question: " Is the labeling correct ?",
            score: 3,
            image: true,
          },
        ],
      },
      {
        category: "Category 2",
        name: "CheckList 3",
        removalScope: true,
        questions: [
          {
            question: " Is the Cable Depth meetings standards ?",
            score: 5,
            image: true,
          },
          {
            question: " Is the labeling correct ?",
            score: 3,
            image: false,
          },
        ],
      },
    ],
  },
  {
    id: 2,
    customerName: "TDS1",
    totalChecklist: 4,
    checklist: [
      {
        category: "Category",
        name: "CheckList 1",
        removalScope: true,
        questions: [
          {
            question: " Is the Cable Depth meetings standards ?",
            score: 4,
            image: true,
          },
          {
            question: " Is the labeling correct ?",
            score: 4,
            image: true,
          },
        ],
      },
      {
        category: "Category 1",
        name: "CheckList 2",
        removalScope: true,
        questions: [
          {
            question: " Is the Cable Depth meetings standards ?",
            score: 4,
            image: true,
          },
          {
            question: " Is the labeling correct ?",
            score: 4,
            image: false,
          },
        ],
      },
      {
        category: "Category 2",
        name: "CheckList 3",
        removalScope: false,
        questions: [
          {
            question: " Is the Cable Depth meetings standards ?",
            score: 2,
            image: false,
          },
          {
            question: " Is the labeling correct ?",
            score: 4,
            image: true,
          },
        ],
      },
      {
        category: "Buried Splice Closure",
        name: "CheckList 4",
        removalScope: false,
        questions: [
          {
            question: " Is the Cable Depth meetings standards ?",
            score: 5,
            image: false,
          },
          {
            question: " Is the labeling correct ?",
            score: 4,
            image: false,
          },
        ],
      },
    ],
  },
  {
    id: 3,
    customerName: "TDS2",
    totalChecklist: 3,
    checklist: [
      {
        category: "Category",
        name: "CheckList 1",
        removalScope: true,
        questions: [
          {
            question: " Is the Cable Depth meetings standards ?",
            score: 5,
            image: true,
          },
          {
            question: " Is the labeling correct ?",
            score: 3,
            image: false,
          },
        ],
      },
      {
        category: "Category 1",
        name: "CheckList 2",
        removalScope: false,
        questions: [
          {
            question: " Is the Cable Depth meetings standards ?",
            score: 5,
            image: true,
          },
          {
            question: " Is the labeling correct ?",
            score: 3,
            image: true,
          },
        ],
      },
      {
        category: "Category 2",
        name: "CheckList 3",
        removalScope: true,
        questions: [
          {
            question: " Is the Cable Depth meetings standards ?",
            score: 5,
            image: true,
          },
          {
            question: " Is the labeling correct ?",
            score: 3,
            image: false,
          },
        ],
      },
    ],
  },
];
